import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignVerticalCentre12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowAlignVerticalCentre12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ArrowAlignVerticalCentre12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M11.5 6.5a.5.5 0 0 0 0-1H8.837l1.267-1.267a.5.5 0 0 0-.708-.707l-2.12 2.122L6.921 6l.353.354 2.121 2.121a.5.5 0 0 0 .708-.707L8.834 6.5zM6 1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9A.5.5 0 0 1 6 1M-.078 6.002a.5.5 0 0 1 .5-.5h2.665L1.818 4.233a.5.5 0 1 1 .707-.707l2.121 2.122L5 6l-.354.354-2.12 2.121a.5.5 0 1 1-.708-.707l1.267-1.267H.422a.5.5 0 0 1-.5-.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ArrowAlignVerticalCentre12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconArrowAlignVerticalCentre12);
